<template>
  <div>
    <j-modal :visible="visible" :width="modalWidth" :title="title" @cancel="cancelModal" @ok="submitModal">
      <!-- 新增、编辑和更换表单 -->
      <template v-if="bigFormType.includes(type)">
        <modalForm ref="modalForm" :detailData="formConfig">
          <template #formItem>
            <a-row v-if="type !== '5'">
              <a-form-item label="运行状态"
                           prop="runningStatus"
                           :labelCol="labelCol"
                           :wrapperCol="wrapperCol">
                <j-dict-select-tag type="list"
                                   allowClear
                                   v-model="form.runningStatus"
                                   dictCode="device_running_status"
                                   placeholder="请选择运行状态" />
              </a-form-item>
            </a-row>
          </template>
        </modalForm>
      </template>
      <a-form-model v-else
                    ref="actionForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="业务日期" prop="recordDate">
          <j-date placeholder="请选择业务日期"
                  v-model="form.recordDate"
                  allowClear
                  style="width: 100%" />
        </a-form-model-item>
        <!-- 禁用展示 -->
        <a-form-model-item v-if="['1'].includes(type)" label="原因" prop="reason">
          <j-dict-select-tag type="list"
                             allowClear
                             v-model="form.reason"
                             dictCode="device_reason"
                             placeholder="请选择原因" />
        </a-form-model-item>
        <!-- 禁用操作展示 -->
        <a-form-model-item v-if="type === '1'" label="方式" prop="mode">
          <j-dict-select-tag type="list"
                             allowClear
                             v-model="form.mode"
                             dictCode="device_mode"
                             placeholder="请选择方式" />
        </a-form-model-item>
        <a-form-model-item v-if="['1', '3'].includes(type)" label="原因描述" prop="reasonDesc">
          <a-input type="textarea" allowclearn v-model="form.reasonDesc" />
        </a-form-model-item>
        <a-form-model-item v-if="type === '1'" label="处理方式" prop="modeDesc">
          <a-input type="textarea" allowclearn v-model="form.modeDesc" />
        </a-form-model-item>
        <a-form-model-item v-if="['4'].includes(type)" label="运行状态" prop="runningStatus">
          <j-dict-select-tag type="list"
                             v-model="form.runningStatus"
                             dictCode="device_running_status"
                             placeholder="请选择运行状态" />
        </a-form-model-item>
      </a-form-model>
    </j-modal>
  </div>
</template>

<script>
import modalForm from '@views/onlineModal/modalForm'
import pageConfig from '../equipmentListConfig'
import moment from 'moment'

export default {
  name: 'actionModal',
  title: '设备管理操作模态框',
  components: { modalForm },
  data() {
    return {
      colAttrs: {
        md: 24,
        xs: 24
      },
      formConfig: {
        formItemKey: 'equipmentSave'
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      form: {
        // 原因
        reason: '',
        // 日期
        recordDate: moment().format("YYYY-MM-DD"),
        // 运行状态   默认为正常
        runningStatus: '10'
      },
      visible: false,
      type: '',
      title: '操作',
      // 新增、编辑、更换表单都走在线表单组件渲染，其余为页面写死
      bigFormType: ['0', '2', '5'],
      rules: {
        modeDesc: [{ required: true, message: '此项必填' }],
        reasonDesc: [{ required: true, message: '此项必填' }],
        mode: [{ required: true, message: '此项必填' }],
        reason: [{ required: true, message: '此项必填' }],
        recordDate: [{ required: true, message: '此项必填' }],
        runningStatus: [{ required: true, message: '此项必填' }]
      }
    }
  },
  computed: {
    // 模态框宽度
    modalWidth() {
      if (this.bigFormType.includes(this.type)) return '40%'
    }
  },
  methods: {
    // 打开模态框
    openModal(type, data) {
      this.type = type
      this.title = pageConfig.actionType[ type ]
      this.form = {
        // 原因
        reason: '',
        // 日期
        recordDate: moment().format("YYYY-MM-DD"),
        // 运行状态   默认为正常
        runningStatus: '10'
      }
      // 移除操作时原因描述非必填
      if(type === '3') {
        this.rules.reasonDesc = null
      }else {
        this.rules.reasonDesc = [{ required: true, message: '此项必填' }]
      }
      // 设置新增表单配置
      if (type === '0') {
        this.formConfig.formItemKey = 'equipmentSave'
        data && this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.modalForm.editForm({
              ...data,
              recordDate: moment().format("YYYY-MM-DD"),
            })
          }, 100)
        })
      }
      // 设置新增编辑表单配置
      if (type === '5') {
        this.formConfig.formItemKey = 'equipmentEdit'
        this.form = data
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.modalForm.editForm(data)
          }, 100)
        })
      }
      // 设置变更表单配置
      if (type === '2') {
        this.formConfig.formItemKey = 'equipmentChange'
      }
      this.visible = true
    },
    // 关闭模态框
    cancelModal() {
      this.visible = false
    },
    // 确认提交模态框
    submitModal() {
      if (this.bigFormType.includes(this.type)) {
        let formInfo = this.$refs.modalForm.getFormData()
        formInfo.form.validateFields((err, values) => {
          if(err) return false
          let data = {
            ...this.form,
            ...values,
          }
          return this.$emit('submit', data, this.type, this.cancelModal)
        })
        return
      }
      this.$refs.actionForm.validate(valid => {
        if (!valid) return false
        return this.$emit('submit', this.form, this.type, this.cancelModal)
      })
    }
  }
}
</script>